// extracted by mini-css-extract-plugin
export default {"mobileMenu":"mobileMenu_mobileMenu__YTYn5","closeContainer":"mobileMenu_closeContainer__akfGL"};